import { render, staticRenderFns } from "./everydayAnswer.vue?vue&type=template&id=be5879c2&scoped=true"
import script from "./everydayAnswer.vue?vue&type=script&lang=js"
export * from "./everydayAnswer.vue?vue&type=script&lang=js"
import style0 from "./everydayAnswer.vue?vue&type=style&index=0&id=be5879c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be5879c2",
  null
  
)

export default component.exports